import { Sparkles } from "lucide-react";
import { LineSheetsHeaderSection } from "../LineSheets";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import type { LineItem } from "@/interfaces/estimate-detail";

type GenerationNotes = NonNullable<LineItem["generationNotes"]>;

const NOTE_FIELDS: { key: keyof GenerationNotes; label: string }[] = [
  { key: "confidenceNotes", label: "Confidence" },
  { key: "formulaNotes", label: "Formula" },
  { key: "templateNotes", label: "Template" },
  { key: "variableNotes", label: "Variable" },
  { key: "unmatchedToTemplate", label: "Unmatched to Template" },
];

const formatValue = (value: string | boolean | undefined) => {
  if (typeof value === "boolean") return value ? "Yes" : "No";
  return value ?? "";
};

export const GenerationNotes = ({ generationNotes }: { generationNotes: GenerationNotes }) => {
  const rows = NOTE_FIELDS.filter(({ key }) => generationNotes[key] !== undefined && generationNotes[key] !== "");

  if (!rows.length) return null;

  return (
    <div className="flex flex-col space-y-2 pt-4">
      <LineSheetsHeaderSection title="Generation Notes">
        <Sparkles className="h-4 w-4" />
      </LineSheetsHeaderSection>

      <div className="px-4">
        <div className="border-border bg-muted/50 max-h-64 overflow-y-auto rounded-lg border">
          <Table className="[&_tr]:border-border/50">
            <TableHeader>
              <TableRow>
                <TableHead className="w-48 pr-4 font-semibold">Field</TableHead>
                <TableHead className="font-semibold">Note</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {rows.map(({ key, label }) => (
                <TableRow key={key}>
                  <TableCell className="text-muted-foreground w-48 pr-4">{label}</TableCell>
                  <TableCell className="whitespace-pre-wrap">{formatValue(generationNotes[key])}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
};
